<a mat-list-item (click)="toggle()" style="width: fit-content;">
    <div fxLayout="row" fxLayoutAlign="space-between stretch" [ngClass]="{'expandido': menuPrincipalService.expandido}"
        class="submenu">
        <div fxLayout="row" fxLayoutAlign="start stretch" matTooltip="Planejamento de Atividades">
            <mat-icon>format_shapes</mat-icon>
            <span *ngIf="menuPrincipalService.expandido" class="nav-caption">Planejamento de Atividades</span>
        </div>
        <div fxLayout="row" fxLayoutAlign="start stretch">
            <mat-icon *ngIf="menuPrincipalService.expandido" style="padding-top: 2px">{{getIcone()}}</mat-icon>
        </div>
    </div>
</a>

<mat-nav-list [ngClass]="{'expandido': menuPrincipalService.expandido}">

    <div [hidden]="!isMostrarSubMenu" [@menuState]="currentState">

        <!-- PLANEJAMENTO_FISIOTERAPIA -->
        <div style="padding-left: 15px">
            <sub-menu *ngIf="verificaAcesso(getModulos().PLANEJAMENTO_FISIOTERAPIA)" icone="accessibility" titulo="Fisioterapia" rota="home" toolTip="Fisioterapia"></sub-menu>
        </div>       
        
        <!-- PLANEJAMENTO_FONOAUDIOLOGIA -->
        <div style="padding-left: 15px">
            <sub-menu *ngIf="verificaAcesso(getModulos().PLANEJAMENTO_FONOAUDIOLOGIA)" icone="line_style" titulo="Fonoaudiologia" rota="home" toolTip="Fonoaudiologia"></sub-menu>
        </div>       
    
        <!-- PLANEJAMENTO_TERAPIA_OCUPACIONAL -->
        <div style="padding-left: 15px">
            <sub-menu *ngIf="verificaAcesso(getModulos().PLANEJAMENTO_TERAPIA_OCUPACIONAL)" icone="list" titulo="Terapia Ocupacional" rota="home" toolTip="Terapia Ocupacional"></sub-menu>
        </div>       
    
        <!-- PLANEJAMENTO_PSICOLOGIA -->
        <div style="padding-left: 15px">
            <sub-menu *ngIf="verificaAcesso(getModulos().PLANEJAMENTO_PSICOLOGIA)" icone="sentiment_satisfied" titulo="Psicologia" rota="home" toolTip="Psicologia"></sub-menu>
        </div>       

    </div>
</mat-nav-list>
    